export function checkStyleAvailability(prop) {
  return prop in document.documentElement.style;
}
